import { TextInput } from "~/components/text_input";
import { useState } from "react";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";
import { Button } from "~/components/button";
import { useTranslation } from "react-i18next";
import submitNotificationRequest from "~/utils/submit_notification_request";
import { SectionHeader } from "~/components/typography";

type Props = {
  urlToken: string;
};

const ExternalNotifications = (props: Props) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation("board");
  const { button_shape, outside_label } = useBoardConfiguration();
  const { urlToken } = props;

  return (
    <div className={"index__external_notifications"}>
      <div className={"index__external_notifications__header"}>
        <SectionHeader>{t("external_notifications.notify_me")}</SectionHeader>
      </div>
      <TextInput
        label={t("external_notifications.email")}
        id={"external_notifications_email"}
        value={email}
        onChange={(e) => setEmail(e.currentTarget.value)}
        outsideLabel={outside_label}
        short={true}
      />
      <div className={"index__external_notifications__button_container"}>
        <Button
          type="submit"
          onClick={async () => {
            setSubmitting(true);
            try {
              await submitNotificationRequest({ email, urlToken });
            } catch (_e) {
              setSubmitting(false);
            }
          }}
          loading={submitting}
          disabled={submitting}
          shape={button_shape || undefined}
        >
          {t("external_notifications.sign_up")}
        </Button>
      </div>
    </div>
  );
};

export default ExternalNotifications;
